import React from 'react';
import '../CSS/Loader.css'; // Import your CSS file for styling

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="spinner"></div>
      <h2>Loading VIGNAN 2K25...</h2>
    </div>
  );
};

export default Loader;
